import { pathMatches } from './path-utils.js';

export function diffJson(left, right) {
  const differences = [];
  walk(left, right, '', differences, true, true);
  return differences;
}

export function filterDifferences(differences, path) {
  return differences.filter((difference) => pathMatches(difference.path, path));
}

function walk(left, right, path, output, leftExists, rightExists) {
  if (!leftExists) {
    output.push({ path, type: 'added', rightValue: right });
    return;
  }
  if (!rightExists) {
    output.push({ path, type: 'removed', leftValue: left });
    return;
  }
  if (Object.is(left, right)) return;

  const leftIsArray = Array.isArray(left);
  const rightIsArray = Array.isArray(right);
  if (leftIsArray && rightIsArray) {
    const length = Math.max(left.length, right.length);
    for (let index = 0; index < length; index += 1) {
      walk(
        left[index],
        right[index],
        joinPath(path, String(index)),
        output,
        index < left.length,
        index < right.length,
      );
    }
    return;
  }

  if (isPlainObject(left) && isPlainObject(right)) {
    const keys = new Set([...Object.keys(left), ...Object.keys(right)]);
    for (const key of keys) {
      walk(
        left[key],
        right[key],
        joinPath(path, key),
        output,
        Object.prototype.hasOwnProperty.call(left, key),
        Object.prototype.hasOwnProperty.call(right, key),
      );
    }
    return;
  }

  output.push({ path, type: 'changed', leftValue: left, rightValue: right });
}

function isPlainObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function joinPath(parent, key) {
  return parent ? `${parent}.${key}` : key;
}
